import type { ShiftOverview } from '@aithora/shared';

/** One open stop on the Care Staff shift. */
export type Task = ShiftOverview['tasks'][number];

/** "15:30" */
export function clock24(t: number): string {
  const d = new Date(t);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/** A new id for one write, so a replayed tap is the same write (the server keeps the first answer). */
export const newId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(16).padStart(8, '0').slice(-8)}-0000-4000-8000-${Math.random().toString(16).slice(2, 14).padEnd(12, '0')}`;
